import { render, staticRenderFns } from "./jobData.vue?vue&type=template&id=265c37be&scoped=true"
import script from "./jobData.vue?vue&type=script&lang=js"
export * from "./jobData.vue?vue&type=script&lang=js"
import style0 from "./jobData.vue?vue&type=style&index=0&id=265c37be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c37be",
  null
  
)

export default component.exports